import styled, { css } from "styled-components";
import tw from "twin.macro";

import { BoxSizingStyle } from "../BoxSizingStyle";
import { FontStyle } from "../FontStyle";
import { CloseSmallIcon } from "../Icons";

interface StyledToastMessageProps {
  $type: "error" | "success" | "general" | "warning";
  $dropShadow?: boolean;
}

export const StyledToastMessage = styled.div<StyledToastMessageProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 36px;
  width: fit-content;
  max-width: 100%;
  padding: 10px 8px 10px 16px;
  border-radius: 18px;

  ${FontStyle}
  ${BoxSizingStyle}

  ${(props) =>
    props.$type === "error" &&
    css`
      background-color: #f1a5a5;
      ${props.$dropShadow &&
      css`
        box-shadow: 0px 7px 12px -4px rgba(234, 179, 179, 0.7);
      `}
    `}

  ${(props) =>
    props.$type === "success" &&
    css`
      background-color: #afdfdb;
      ${props.$dropShadow &&
      css`
        box-shadow: 0px 7px 12px -4px rgba(182, 218, 215, 0.7);
      `}
    `}

  ${(props) =>
    props.$type === "general" &&
    css`
      background-color: #bddff6;
      ${props.$dropShadow &&
      css`
        box-shadow: 0px 7px 12px -4px rgba(166, 199, 220, 0.7);
      `}
    `}

  ${(props) =>
    props.$type === "warning" &&
    css`
      background-color: #ffffd1;
      ${props.$dropShadow &&
      css`
        box-shadow: 0px 7px 12px -4px rgba(242, 242, 208, 0.7);
      `}
    `}
`;

export const StyledToastMessageText = styled.div`
  ${tw`tw-text-caption-1`}
  ${tw`tw-font-bold`}
  ${tw`tw-truncate`}
  ${tw`tw-mr-2`}
  color: rgba(48, 48, 55, 0.65);
`;

export const StyledCloseSmallIcon = styled(CloseSmallIcon)`
  fill: rgba(48, 48, 55, 0.3);
  flex-shrink: 0;
  cursor: pointer;

  &:hover {
    fill: rgba(48, 48, 55, 0.65);
  }
`;

StyledToastMessage.displayName = "StyledToastMessage";
StyledCloseSmallIcon.displayName = "StyledCloseSmallIcon";
